'use client'

import { ChakraProvider } from '@chakra-ui/react'
import { system } from '@/utils/theme'
import { ColorModeProvider } from './color-mode'

export function Provider(props) {
  return (
    <ColorModeProvider>
      <ChakraProvider value={system}>{props.children}</ChakraProvider>
    </ColorModeProvider>
  )
}
